export const isStateCurrentlyActive = (from: number, until: number) => {
  const now = Date.now();
  const isActive = from <= now && until >= now;

  return isActive;
};
